<template>
  <div class="swiper-home-banner">
    <div class="swiper-wrapper">
      <div class="swiper-slide" v-for="(item, index) in bannerList" :key="index">
        <img class="banner_img" :src="item.image" />
        <div class="banner_cover" v-if="index == 0" style="background-color: rgba(0, 0, 0, 0)"></div>
        <div class="banner_cover" v-if="index == 1" style="background-color: rgba(0, 0, 0, 0.3)"></div>
        <div class="banner_cover" v-if="index == 2" style="background-color: rgba(0, 0, 0, 0.1)"></div>
        <div class="banner_title" :style="item.style">
          <div v-if="index == 0 || index == 2">
            {{ item.title }}
            <div class="banner_text">{{ item.text }}</div>
          </div>
          <div v-else>
            <div class="banner_text_1">全场景</div>
            <div class="banner_text_1">服务所有类型充电场站</div>
            <div class="banner_text_1" style="margin-top: 20%">一站式</div>
            <div class="banner_text_1">充电站智能管控设备全品类</div>
            <div class="banner_text_1" style="margin-top: 20%">覆盖广</div>
            <div class="banner_text_1">施工运维体系覆盖全国</div>
          </div>
        </div>
      </div>
    </div>
    <div class="swiper-home-banner-pagination"></div>
  </div>
</template>
<script>
// swiper
import Swiper from "swiper";
export default {
  data() {
    return {
      bannerList: [
        {
          title: "",
          text: "新能源充电智能管控解决方案",
          image: require("@/assets/images/banner/pic_01.png"),
          style: "width:100%;text-align:center;",
        },
        {
          title: "一站式",
          text: "充电场站智能管控设备全品类",
          image: require("@/assets/images/banner/pic_11.jpg"),
          style: "left:15%;top:20%",
        },
        {
          title: "",
          text: "电喵科技 · 让充电更简单",
          image: require("@/assets/images/banner/pic_03.jpeg"),
          style: "width:100%;text-align:center;top:50%;box-sizing:border-box;padding-left:5%",
        },
      ],
    };
  },
  mounted() {
    // 轮播图组件
    this.bannerSwiper = new Swiper(".swiper-home-banner", {
      // effect: "cube", // 切换效果
      autoplay: {
        delay: 6000,
      }, // 自动播放
      loop: true, // 无限循环
      direction: "horizontal", // 方向
      mousewheel: false, // 鼠标滚动切换
      pagination: {
        el: ".swiper-home-banner-pagination", // 标签
        clickable: true, // 可点击
        bulletClass: "home-banner-bullet", // 样式
        bulletActiveClass: "home-banner-bullet-active", // 选中样式
      },
    });
  },
};
</script>

<style lang="scss" scoped>
@import "swiper/css/swiper.min.css";
@import "@/assets/style/home-banner-swiper.css";
.swiper-home-banner {
  width: 100vw;
  min-width: 960px;
  height: 100vh;
  overflow: hidden;
  position: relative;

  .banner_img {
    width: 100%;
    height: 100%;
  }

  .banner_cover {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;

    // background: linear-gradient(
    //   to bottom,
    //   /* 渐变方向从上到下 */ rgba(0, 0, 0, 1) 0%,
    //   /* 渐变方向从上到下 */ rgba(0, 0, 0, 1) 40%,
    //   /* 透明 */ rgba(0, 0, 0, 0.9) 90%,
    //   /* 半透明黑 */ rgba(0, 0, 0, 0) 100% /* 更深的透明黑 */
    // );
    // backdrop-filter: blur(5px) saturate(180%);
    // -webkit-backdrop-filter: blur(5px) saturate(180%);
  }

  .banner_title {
    z-index: 20;
    position: absolute;
    top: 45%;
    color: #fff;
    font-size: 0.2rem;
    font-weight: 500;
    -webkit-user-select: none; /* Safari */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* IE10+ */
    user-select: none; /* Standard syntax */
    @media screen and (max-width: 960px) {
      font-size: 47px;
      top: 45%;
    }

    .banner_text {
      z-index: 20;
      font-size: 4.5rem;
      @media screen and (max-width: 960px) {
        font-size: 42px;
      }
    }

    .banner_text_1 {
      z-index: 20;
      font-size: 2rem;
      @media screen and (max-width: 960px) {
        font-size: 18px;
      }
    }
  }

  .banner_more {
    width: 200rem;
    height: 60rem;
    border-radius: 20px;
    position: absolute;
    margin: 0 auto;
    left: calc(50vw - 100rem);
    bottom: 15%;
    background-color: #000000;
    color: #999;
    text-align: center;
    line-height: 60rem;
    font-size: 20rem;
    border: 1px solid #fff;
    box-shadow: 0 0 10rem 10rem rgba(0, 0, 0, 0.7);
    cursor: pointer;
    z-index: 100;
    transition: box-shadow 0.2s;
  }

  .banner_more:hover {
    box-shadow: 2px 4px 12px rgba(0, 0, 0, 0.4);
  }

  .banner_more:active {
    box-shadow: 0 0 5rem 5rem rgba(100, 100, 100, 1) inset;
  }

  .swiper-slide {
    position: relative;
    .banner_cover_text {
      position: absolute;
      display: flex;
      left: 10%;
      bottom: 20%;
      z-index: 100;
      color: #fff;

      .banner_cover_item {
        padding: 1vw 2vw;
        border: 1px solid #fff;
        margin: 10px;
        cursor: pointer;
      }

      .banner_cover_item:hover {
        color: #000;
      }
    }
  }
}
</style>
